export interface ChartWeeksSalesOrders {
  orderDate: Date;
  numberOfOrders: number;
  quantity: number;
  value: number;
}
